import React from 'react'
import styles from './styles.css'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import Button from 'orionsoft-parts/lib/components/Button'
import useMessage from 'App/hooks/useMessage'

export default function CallToAnswer(props) {
  const mutate = useMutate()
  const showMessage = useMessage()
  const call = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation callVehicleAndSay($vehicleId: ID) {
            callVehicleAndSay(vehicleId: $vehicleId)
          }
        `,
        variables: {
          vehicleId: props.vehicle._id
        },
        refetchQueries: ['getConversationCalls']
      })
      showMessage('Se va a llamar al driver')
    } catch (error) {
      showMessage(error)
    }
  }
  return (
    <div className={styles.container}>
      <Button onClick={call}>Llamar para que conteste</Button>
    </div>
  )
}
